<template>
  <div
    class="collapse"
    :class="visible ? 'open' : ''"
  >
    <div
      class="collapse__trigger"
      @click="visible = !visible"
      :class="visible ? 'not-collapsed' : 'collapsed'"
    >
      <slot name="trigger" />
    </div>
    <transition
      name="collapse"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div
        class="collapse__wrapper"
        v-show="visible"
      >
        <div class="collapse__content">
          <slot name="content" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Collapse',

  props: {
    closed: { type: Boolean, default: false }
  },

  data () {
    return {
      visible: !this.closed
    }
  },

  methods: {
    start (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    end (el) {
      el.style.height = ''
    }
  },

  watch: {
    visible (a) {
      if (a) {
        this.$parent.$children.filter(e => e.$options.name == this.$options.name && e._uid != this._uid).forEach(e => e.visible = false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse{
	margin-bottom: 10px;
	&__trigger{
		cursor: pointer;
	}
	&-enter-active,
	&-leave-active{
		will-change: height, opacity;
		transition: height 0.3s ease, opacity .3s ease;
		overflow: hidden;

	}
	&-enter,
	&-leave-to {
		height: 0 !important;
		opacity: 0;
	}
}
</style>
